import React from "react";
import { Button, Col, Row, Flex } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import CommanPreviewImage from "../../../components/common/CommanPreviewImage";


const ViewRetailSection = ({
  leadViewDetails,
  retailData,
  handleViewBooking,
}) => {
  return (
    <div className="view-section lead-detail">
      <Row gutter={20}>
        {/* Retail Status */}
        <Col xs={24} sm={24} md={24} lg={12}>
          <Flex className="view-fields">
            <h6>Retail Status:</h6>
            <div className=" value ">
              {leadViewDetails?.retail?.retail_status === 1
                ? "Retailed"
                : "Not Retailed"}
            </div>
          </Flex>
        </Col>
        {/* Booking redirect icon */}
        <Col xs={24} sm={24} md={24} lg={12}>
          <Flex className="view-fields">
            <h6>Booking Details:</h6>
            <Button
              shape="circle"
              icon={<EyeOutlined />}
              onClick={handleViewBooking}
            />
          </Flex>
        </Col>

        {/* Date of Retail */}
        <Col md={12} sm={12} xs={24}>
          <Flex className="view-fields">
            <h6>Date of Retail:</h6>
            <div className=" w-100 value ">
              {leadViewDetails?.retail?.retail_date
                ? dayjs(leadViewDetails?.retail?.retail_date).format(
                  "DD MMM YYYY"
                )
                : "-"}
            </div>
          </Flex>
        </Col>
        {/* Engine Number */}
        <Col md={12} sm={12} xs={24}>
          <Flex className="view-fields ">
            <h6>Engine Number:</h6>
            <div className=" value">
              {retailData?.engine_number ? retailData?.engine_number : "-"}
            </div>
          </Flex>
        </Col>

        <Col md={12} sm={12} xs={24}>
          <Flex className="view-fields ">
            <h6>Chassis Number:</h6>
            <div className=" value">
              {leadViewDetails?.allocated_chassis_number
                ? leadViewDetails?.allocated_chassis_number
                : "-"}
            </div>
          </Flex>
        </Col>

        {/* Attachment */}
        <Col md={12} sm={12} xs={24}>
          <Flex className="view-fields">
            <h6>Attachment:</h6>
            <div className=" value">
              {leadViewDetails?.retail?.retail_documents &&
                Array.isArray(leadViewDetails?.retail?.retail_documents) &&
                leadViewDetails?.retail?.retail_documents.length > 0 ? (
                (() => {
                  // Filter documents that have valid file paths
                  const validDocuments =
                    leadViewDetails.retail.retail_documents.filter(
                      (doc) => doc.document_path
                    );

                  // If no valid documents, show "-"
                  if (validDocuments.length === 0) {
                    return <div>-</div>;
                  }

                  // Render links only for documents with valid paths
                  return (
                    <div className="d-flex flex-column align-items-start">
                      {validDocuments.map((doc, index) => {
                        const filePath = doc.document_path;
                        const fileName =
                          doc.document_file_name || `Attachment ${index + 1}`;

                        // Only render link if file path exists and is not empty
                        if (filePath && filePath.trim() !== "") {
                          return (
                            <a
                              key={index}
                              href={filePath}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="me-2 mb-1"
                            >
                              {fileName}
                            </a>
                          );
                        }
                        return null;
                      })}
                    </div>
                  );
                })()
              ) : (
                <div>-</div>
              )}
            </div>
          </Flex>
        </Col>

        {/* Upload Picture */}
        <Col md={12} sm={12} xs={24}>
          <Flex
            className={`view-fields ${leadViewDetails?.retail?.document_path ? "picture-uploaded" : ""
              }`}
          >
            <h6 className="me-2">
              {leadViewDetails?.retail?.document_path
                ? "Uploaded Picture:"
                : "Upload Pictures:"}
            </h6>
            <div className="value">
              {leadViewDetails?.retail?.document_path ? (
                <CommanPreviewImage
                  width={70}
                  height={70}
                  src={leadViewDetails?.retail?.document_path}
                />
              ) : (
                <div>-</div>
              )}
            </div>
          </Flex>
        </Col>

        <Col md={12} sm={12} xs={24}>
          <Flex
            className={`view-fields  ${leadViewDetails?.retail?.iconnect_doc_path
                ? "picture-uploaded"
                : ""
              }`}
          >
            <h6 className="me-2">
              {leadViewDetails?.retail?.iconnect_doc_path
                ? "IConnect:"
                : "IConnect:"}
            </h6>
            <div className="m-0 w-50 value mb-sm-2">
              {leadViewDetails?.retail?.iconnect_doc_path ? (
                <CommanPreviewImage
                  width={70}
                  height={70}
                  src={leadViewDetails?.retail?.iconnect_doc_path}
                />
              ) : (
                <div>-</div>
              )}
            </div>
          </Flex>
        </Col>

        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
          <Flex className="view-fields feedbacks ">
            <h6>Delivery Feedback:</h6>
            <div className="value">
              {retailData?.delivery_feedback
                ? retailData?.delivery_feedback
                : "-"}
            </div>
          </Flex>
        </Col>

        {/* Retail Remarks */}
        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
          <Flex className="view-fields ">
            <h6 className="me-2">Retail Remarks:</h6>
            <div className=" value ">
              {leadViewDetails?.retail?.retail_remarks
                ? leadViewDetails?.retail?.retail_remarks
                : "-"}
            </div>
          </Flex>
        </Col>


      </Row>
    </div>
  );
};

export default ViewRetailSection;
